import { CSSProperties } from "react";
import { Typography } from "@mui/material";
import { parseDate } from "Backend";
import { format } from "date-fns";

export interface DateRangeProps {
  start?: string | Date | null;
  end?: string | Date | null;
  format?: string;
  style?: CSSProperties;
}

const DateRange = (props: DateRangeProps) => {
  const startAsDate = props.start
    ? typeof props.start === "string"
      ? parseDate(props.start)
      : props.start
    : undefined;
  const endAsDate = props.end ? (typeof props.end === "string" ? parseDate(props.end) : props.end) : undefined;

  const useFormat = props.format || "MM/dd/yyyy";

  const startFormatted = startAsDate ? format(startAsDate, useFormat) : "";
  const endFormatted = endAsDate ? format(endAsDate, useFormat) : "";

  const rangeFormatted = startFormatted === endFormatted ? startFormatted : startFormatted + " - " + endFormatted;

  return <Typography style={props.style}>{rangeFormatted}</Typography>;
};

export default DateRange;
